<template>
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.625 2.625H14.875M14.875 2.625V6.875M14.875 2.625L9.91667
       7.58333M6.375 15.375H2.125M2.125 15.375V11.125M2.125 15.375L7.08333 10.4167"
      stroke="#7B87A5"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>